import styled from "styled-components";
import {LiveCasinoGridItemTitleDefaultBox} from "./live-casino-grid-item-title.default.box";

export const LiveCasinoGridItemTitleMrGreenBox = styled(LiveCasinoGridItemTitleDefaultBox)`
    color: ${props => props.theme.colors.textDark};
    ${props => props.theme.font.presets.light}
`;
